module.exports = __webpack_public_path__ + "files/33c8b27ffffa5b9722bf32441ba61111.png";